/**
 * Custom TipTap Image extension for partner images.
 *
 * Stores images as `![alt](partner-image:{imageId})` in markdown.
 * At render time, resolves `partner-image:{imageId}` URLs to presigned URLs
 * via PartnerImageService.
 *
 * Provides custom markdown serialization/parse rules so that
 * `partner-image:` URLs survive markdown roundtrips correctly.
 */

import Image from "@tiptap/extension-image";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import PartnerImageNodeView from "./PartnerImageNodeView.vue";

export const PARTNER_IMAGE_PREFIX = "partner-image:";

export const PartnerImageExtension = Image.extend({
  name: "image",

  addNodeView() {
    return VueNodeViewRenderer(PartnerImageNodeView);
  },

  addStorage() {
    return {
      markdown: {
        serialize(state: any, node: any) {
          const src = node.attrs.src || "";
          const alt = node.attrs.alt || "";
          const title = node.attrs.title;
          if (title) {
            state.write(`![${alt}](${src} "${title}")`);
          } else {
            state.write(`![${alt}](${src})`);
          }
        },
        parse: {
          // No special DOM transform needed for images —
          // tiptap-markdown natively parses ![alt](src) into <img> tags
          // which the Image extension picks up via parseDOM.
        }
      }
    };
  }
});
